import React from 'react'
import Row from '../components/Layout/Row'
import Col from 'reactstrap/lib/Col'
import image from '../../img/banner3-PR-persona.png'
import { useTranslator } from '../../hooks'
import Section from '../components/Layout/Section'

const TransferEndBanner = () => {
  const translator = useTranslator()
  return (
    <Section className={'MainBanner'} bgColor={'primary'}>
      <Row flexWrap={'nowrap'} noGutters>
        <Col>
          <h1
            className={'h1 text-uppercase'}
            dangerouslySetInnerHTML={{
              __html: translator('banner.end.title'),
            }}
          />
          <h2
            className={'h2'}
            dangerouslySetInnerHTML={{
              __html: translator('banner.end.description'),
            }}
          />
        </Col>
        <Col>
          <img src={image} alt={''} />
        </Col>
      </Row>
    </Section>
  )
}

export default TransferEndBanner
